import React from "react";
import * as dc from "dc";
import * as d3 from 'd3';
import { ChartTemplate } from "./chartTemplate";

//const self = this;
const barChartFunc = (divRef, ndx) => {
    let grade_range;
    const myChart = dc.rowChart(divRef);

    const dimension = ndx.dimension(function (d) {
      grade_range = d.s_level;
      return grade_range;
    });


    const group = dimension.group().reduce(
     function(p, v) { // add
       //if(v.dsubmissiom.getMonth() == 3)
       ++p.count;
       if(p.count > 0) {
         p.totalWords += v.n_of_words;
         p.avgWords = Math.floor(parseFloat(100*p.totalWords/p.count))/100;
         p.totalVocabulary += v.vocabulary_used;
         p.avgVocabulary = Math.floor(parseFloat(100*p.totalVocabulary/p.count))/100;
         if(v.project_id in p.p_ids){
           p.p_ids[v.project_id] += 1
         }
         else{
             p.p_ids[v.project_id] = 1;
             p.id_count++;
         }
         if(v.student in p.students){
           p.students[v.student] += 1
         }
         else{
             p.students[v.student] = 1;
             p.student_count++;
         }
       }
       else {
         p.avgWords = 0;
         p.totalWords = 0;
         p.totalVocabulary = 0;
         p.avgVocabulary = 0;
         p.id_count = 0;
         p.p_ids = {};
         p.student_count = 0;
         p.students = {};
       }
       return p;
     },
     function(p, v) { // remove
       //if(v.dsubmissiom.getMonth() == 3)
       --p.count;
       if(p.count > 0) {
         p.totalWords -= v.n_of_words;
         p.avgWords = Math.floor(parseFloat(100*p.totalWords/p.count))/100;
         p.totalVocabulary -= v.vocabulary_used;
         p.avgVocabulary = Math.floor(parseFloat(100*p.totalVocabulary/p.count))/100;
         if(v.project_id in p.p_ids){
           p.p_ids[v.project_id] -= 1
         }
         if(p.p_ids[v.project_id] === 0){
             delete p.p_ids[v.project_id];
             p.id_count--;
         }
         if(v.student in p.students){
           p.students[v.student] -= 1
         }
         if(p.students[v.student] === 0){
             delete p.students[v.student];
             p.student_count--;
         }
       }
       else {
         p.avgWords = 0;
         p.totalWords = 0;
         p.totalVocabulary = 0;
         p.avgVocabulary = 0;
         p.id_count = 0;
         p.p_ids = {};
         p.student_count = 0;
         p.students = {};
       }
       return p;
     },
     function() { // init
         return {count: 0, totalWords: 0, avgWords: 0, totalVocabulary: 0, avgVocabulary: 0,id_count: 0, p_ids: {}, student_count: 0,
          students: {}};
     }
   );

  const size = group.size();
  const barHeight = 17;
  let LabelPadding = 0;
  let counter = 0;

  const scale = d3.scaleOrdinal()
      .domain(['0 - 2', '2 - 2.2','2.2 - 2.4','2.4 - 2.6','2.6 - 2.8','2.8 - 3','3 - 3.2','3.2 - 3.4','3.4 - 3.6','3.6 - 3.8','3.8 - 4'])
      .range([0,1,2,3,4,5,6,7,8,9,10]);

  myChart
    .dimension(dimension)
    .group(group)
    .valueAccessor(function (p) {
       return p.value.count ;
     })
     //.ordering(function(d){ return d.value.count})
    .elasticX(true)
    //.elasticY(true)
    .ordering(function(k){
      return scale(k.key);
    })
    .ordering(function(d){
      if(d.s_level == '0 - 2') return 0;
      else if(d.s_level == '2 - 2.2') return -1;
      else if(d.s_level == '2.2 - 2.4') return -2;
      else if(d.s_level == '2.4 - 2.6') return -3;
      else if(d.s_level == '2.6 - 2.8') return -4;
      else if(d.s_level == '2.8 - 3') return -5;
      else if(d.s_level == '3 - 3.2') return -6;
      else if(d.s_level == '3.2 - 3.4') return -7;
      else if(d.s_level == '3.4 - 3.6') return -8;
      else if(d.s_level == '3.6 - 3.8') return -9;
      else if(d.s_level == '3.8 - 4') return -10;
    })
    .width(250)
    //.y(d3.scaleOrdinal().domain(grade_range))
    // .yUnits(dc.units.ordinal)
    .labelOffsetX(-100)
    .height(30 + size*(barHeight+2))
    .ordinalColors([ "#065FE5"])
    .transitionDuration(1000)
    .margins({ top: 5, right: 30, bottom: 25, left: 100 })
    .renderTitleLabel(true)
    .title(function(d) {
      return d3.format(",d")(d.value.count); // or your custom value accessor
    })
    .fixedBarHeight(barHeight)
    .gap(2)
    .xAxis().ticks(1)
    //.cap(10);

    myChart.on('pretransition', function(chart) {
      chart.select('svg')
        .classed('centered', true)
      const padding = 10;
      const maxWidth = chart.effectiveWidth();
      const label = chart.selectAll('g.row > text:nth-child(3)'); //find all row labels
      const row = chart.selectAll('g.row > rect');
      row.attr('x', maxWidth/2)
      label.attr('x', padding) //move labels to starting position

      label.classed('row_center', true)

      .transition() //start transition
      .duration(chart.transitionDuration()) //use chart's transitionDuration so labels animate with rows
      .attr('x', function(d){ //set label final position
          var dataValue = chart.valueAccessor()(d); //use chart's value accessor as basis for row label position
          var scaledValue = chart.xAxis().scale()(dataValue); //convert numeric value to row width
          // if(scaledValue < 30) {
          //   d.LabelPadding = padding;
          //   return  padding;
          // }
          d.LabelPadding = scaledValue - padding;
          return (maxWidth )/2; //return scaled value to set label position
      })
      label.classed('label_text',function(d) {
        if(d.LabelPadding <= padding)
          return false;
        else return true;
      })
      label.classed('label_text1',function(d) {
        if(d.LabelPadding > padding)
          return false;
        else return true;
      })


      row.attr('x', function(d){ //set label final position
          var dataValue = chart.valueAccessor()(d); //use chart's value accessor as basis for row label position
          var scaledValue = chart.xAxis().scale()(dataValue);
          return (maxWidth - scaledValue)/2
      })

      function AddXAxis(chart, displayText) {
        counter++;
            chart.svg()
                .append("text")
                .attr("class", "x-axis-label")
                .attr("text-anchor", "middle")
                .attr("x", (70 + chart.width()) / 2)
                .attr("y", chart.height()-5)
                .attr("font-size", 14)
                .text(displayText);
        }
        if(counter == 0) AddXAxis(myChart, "Aggregate");
    });

    return myChart
}

export const StudentGrades = props => (
  <ChartTemplate chartFunction={barChartFunc} title={props.title} dim={props.dim} metric={props.metric} type={props.type}
    showMetricsSelector={props.showMetricsSelector} studentGradesMetric={props.studentGradesMetric} reset={props.reset}/>
)
